import React, { ReactNode, useEffect, useState } from 'react'
import { IDataDisplayerItemField } from './DataDisplayer'
import { Avatar } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import Countries from '../../features/locations/Countrries'
import DateAndTime from '../../features/DateAndTime'
import { Link } from 'react-router-dom'
import StatusChip from '../StatusChip'
import CurrentItemLocation from '../../features/items/CurrentItemLocation'
import { IItemModel } from '../../features/items/ItemsApp'
import { IAxiosDefaultDataObject } from '../../config'
import NoImage from "../../assets/img/no-thumb.png"
import Thumbnail from '../Thumbnail'

interface IBaseItemFieldProps {
    children: ReactNode,
    maxWidth: number,
    minWidth: number,
    isActionButtons?: boolean,
    type: string,
    quickItemView?: (item: IAxiosDefaultDataObject, shown: boolean, handleHide: () => void) => JSX.Element
    rawItem: { [key: string]: any }
}
export const BaseDataDisplayerItemField: React.FC<IBaseItemFieldProps> = ({ children, ...props }) => {

    const { maxWidth, minWidth, isActionButtons, type, quickItemView, rawItem } = props

    const baseContainerClassName: string = "data-displayer-single-field-item" + " " + type
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    const [showQuickItemView, setShowQuickItemView] = useState<boolean>(false)

    const handleCloseQuickItemView = () => setShowQuickItemView(false)

    const handleOnClick = () => {
        if (quickItemView){
            setShowQuickItemView(true)
        }
    }

    useEffect(() => {
        if (quickItemView){
            setContainerClassName(`${containerClassName} with-quick-item-view`)
        }
    }, [quickItemView])

    return(
        <div onClick={() => handleOnClick()} className={isActionButtons ? `${containerClassName} action-buttons` : containerClassName} style={{ maxWidth: !isActionButtons ? maxWidth : "", minWidth: !isActionButtons ? minWidth : "" }}>
            <div className="content-of-data-displayer-single-field-item">
                {children}
                {quickItemView && quickItemView(rawItem, showQuickItemView, handleCloseQuickItemView)}
            </div>
        </div>
    )
}

interface IDataDisplayerItemFieldProps extends IDataDisplayerItemField {
    hideColumns: Array<string>,
    showLabel?: boolean,
    rawItem: { [key: string]: any }
}

export default function DataDisplayerItemField(props: IDataDisplayerItemFieldProps) {

    const { id, value, type, hideColumns, label, showLabel, link, rawItem, quickItemView, customContent } = props

    const dateAndTime = new DateAndTime()

    let minWidth = props.minWidth ? props.minWidth : 200
    let maxWidth = props.maxWidth ? props.maxWidth : 200

    if (type == "thumbnail"){
        minWidth = 120
        maxWidth = 120
    }

    if (hideColumns.includes(id)){
        return <></>
    }

    if (customContent){
        return(
            <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                {customContent(rawItem)}
            </BaseDataDisplayerItemField>
        )
    }

    switch(type){

        case "thumbnail":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {/* <Avatar src={value ? value : NoImage}><GenerateIcon icon="image" /></Avatar> */}
                    <Thumbnail src={value ? value : NoImage} />
                </BaseDataDisplayerItemField>
            )

        case "title":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {link ? <Link to={link}><h3 className="title field-item-title">{value}</h3></Link> : <h3 className="title field-item-title">{value ? value : "-"}</h3>}
                </BaseDataDisplayerItemField>
            )

        case "text":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {showLabel && <h4>{label}</h4>}
                    {link ? <Link to={link}><h3 className="title">{value}</h3></Link> : <h3 className="title">{value ? value : "-"}</h3>}
                </BaseDataDisplayerItemField>
            )

        case "date":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {showLabel && <h4>{label}</h4>}
                    <h3 className="title">{value ? dateAndTime.formatDateAndTime(value) : "-"}</h3>
                </BaseDataDisplayerItemField>
            )

        case "country":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {showLabel && <h4>{label}</h4>}
                    <h3 className="title">{Countries.returnCountryNameBaseByValue(value)}</h3>
                </BaseDataDisplayerItemField>
            )

        case "status":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {showLabel && <h4>{label}</h4>}
                    <StatusChip type={value} />
                </BaseDataDisplayerItemField>
            )

        case "current-location":
            return(
                <BaseDataDisplayerItemField rawItem={rawItem} quickItemView={quickItemView} type={type} maxWidth={maxWidth} minWidth={minWidth}>
                    {showLabel && <h4>{label}</h4>}
                    <CurrentItemLocation item={(rawItem as IItemModel)} />
                </BaseDataDisplayerItemField>
            )

        default:
            return <></>
    }
}